import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VBtn,{staticClass:"new-contact",attrs:{"icon":""},on:{"click":_vm.handleCreateContact}},[_c(VIcon,[_vm._v("person_add")])],1),_c('create-contact-choice-modal',{attrs:{"show":_vm.showChoiceModal},on:{"close":function($event){_vm.showChoiceModal = false},"create":_vm.onCreateContactChoice}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }